var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.667L17.5 5.833v11.674a.827.827 0 01-.828.826H3.327a.833.833 0 01-.827-.826V2.493c0-.456.37-.826.828-.826h10.005zm-2.059 10.371l1.842 1.842 1.179-1.178-1.842-1.841a3.334 3.334 0 10-6.2-1.904 3.333 3.333 0 005.021 3.081zm-.515-1.693a1.67 1.67 0 01-1.83.385 1.667 1.667 0 111.83-.385z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/paper-search.svg";
export { SvgPaperSearch as ReactComponent };